export default {
  methods: {
    /**
     * Возвращает название ПС.
     *
     * @param {String} sengine
     * @returns {string}
     */
    getSengineName (sengine) {
      switch (sengine) {
        case this.$getConst('SENGINE_YANDEX'):
          return 'Яндекс'

        case this.$getConst('SENGINE_GOOGLE'):
          return 'Google'
      }

      return ''
    },
    getSengineName1C (sengine) {
      switch (sengine) {
        case this.$getConst('SENGINE_YANDEX'):
          return 'Яндекс'

        case this.$getConst('SENGINE_GOOGLE'):
          return 'Гугл'
      }

      return ''
    }
  }
}
